import axios from 'axios';

const urlApi = 'https://viacep.com.br/ws';

export const findAddressByCep = (postalCode: string) => axios.get(`${urlApi}/${postalCode}/json`);